export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10110.466a1b89.jpg";